import { getImageGalleryOnboardDismissedValue } from "../helpers";

export const updateImageGalleryOnboardDismissedReducer = (
  state,
  { payload },
) => {
  state.imageGalleryOnboardDismissed =
    getImageGalleryOnboardDismissedValue(payload);
};
